/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Grower_Area_View_CameraInputs */

const vi_grower_area_view_camera = /** @type {(inputs: Grower_Area_View_CameraInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Camera (${i?.count})`)
};

/**

* @param {Grower_Area_View_CameraInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_view_camera = /** @type {((inputs: Grower_Area_View_CameraInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_View_CameraInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_view_camera(inputs)
});